import { service } from "infrastructure";
import { isSuccessResponse } from "presentation/common";

export async function loadDocumentDetailAction(id, dispatch) {
  try {
    const response = await service.getDocumentDetail(id);

    if (isSuccessResponse(response)) {
      return dispatch.documentDetail.loadDocumentDetailSuccessAction(
        response.data || []
      );
    }

    dispatch.documentDetail.loadDocumentDetailFailureAction(
      response.data || {}
    );
  } catch (e) {
    dispatch.documentDetail.loadDocumentDetailFailureAction({ error: null });
  }
}

export function downloadComponentsAction(state) {
  const { documentDetail } = state;
  service.downloadMyDetailDocuments(documentDetail.documents);
}
